import axios from "axios";
import Swal from "sweetalert2";
import session from "@/kuaa/kuaa-sessions";

const cors = require("cors");
const querystring = require("querystring");

let modalOptions = {
  //      title: "목록 조회",
  showCancelButton: false,
  confirmButtonText: "확인",
  buttonsStyling: false
};

axios.interceptors.request.use(
  function(config) {
    modalOptions.showConfirmButton = false;

    Swal.fire({
      title:
        '<img src="/img/roll.gif" style="object-fit: contain; margin-right: 10px;">데이터 수신중<style>.swal2-popup{width: 220px!important; height: 69px!important;    min-height: auto!important;    width: 340px!important;-webkit-box-shadow: 0px 0px 10px -2px rgba(0,0,0,0.75);-moz-box-shadow: 0px 0px 10px -2px rgba(0,0,0,0.75);box-shadow: 0px 0px 10px -2px rgba(0,0,0,0.75);}</style>',
      showConfirmButton: false,
      allowOutsideClick: false
    });
    cors({ origin: "https://balsong.com/Linkage/API/", credentials: true });
    return config;
  },
  function(error) {
    Swal.close();
    console.log("ERROR :: request loading finished!!!");
    return Promise.reject(error);
  }
);

// 응답 인터셉터
axios.interceptors.response.use(
  function(response) {
    Swal.close({});
    return Promise.resolve(response);
  },
  function(error) {
    Swal.close();
    console.log("ERROR :: response loading finished!!!", error);
    return Promise.reject(error);
  }
);

const kuaaApi = {
  sendServer(url, options, method, callback, isNotToken) {
    let header = {
      "Content-Type": "application/json;charset=UTF-8",
      "X-Auth-Token": session.get("token")
    };
    if (isNotToken)
      header = { "Content-Type": "application/json;charset=UTF-8" };
    axios({
      method: method,
      headers: header,
      url: url,
      data: options
    })
      .then(response => {
        modalOptions.showConfirmButton = true;
        let isError = false;
        let errorMsg = `서버 통신 과정에서 오류가 발생했습니다.`;
        let resCode = null;

        // API framework call Error
        if (response && response.resultCode && response.resultCode) {
          resCode = response.resultCode;
          if (resCode !== "MC000") {
            isError = true;
            if (response.resultMessage) errorMsg = response.resultMessage;
          }

          // 저장(트랜잭션발생) 시 APiKuaaRestResult로 return시
        } else if (
          response &&
          response.data &&
          response.data &&
          response.data.resultCode
        ) {
          resCode = response.data.resultCode;
          if (resCode !== "MC000") {
            isError = true;
            if (response.data.resultMessage)
              errorMsg = response.data.resultMessage;
          }

          //  ToastUI API framework call
        } else if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.resultCode
        ) {
          resCode = response.data.data.resultCode;
          if (resCode !== "MC000") {
            isError = true;
            if (response.data.data.resultMessage)
              errorMsg = response.data.data.resultMessage;
          }
        }

        if (isError) {
          modalOptions.html = errorMsg;

          //9102- 토큰 유효기간 경과, 9104- 토큰미존재  인 경우 로그인 페이지로 메세지 출력후 로그인 페이지로 보내 재로그인 하도록 처리
          if (resCode == "9102" || resCode == "9104") {
            Swal.fire(modalOptions).then(result => {
              if (result.value) {
                window.location = "/login";
              }
            });
          } else {
            Swal.fire(modalOptions);
          }
        } else {
          callback(response);
        }
      })
      .catch(error => {
        console.log(`kuaaApi.sendServer() failed : ${error}`);
        if (process.env.NODE_ENV === "production") {
          modalOptions.html = `서버 통신 과정에서 오류가 발생했습니다.`;
        } else {
          modalOptions.html = error
            ? error
            : `서버 통신 과정에서 오류가 발생했습니다.`;
        }
        Swal.fire(modalOptions);
      });
  },

  sendServer2(url, options, method, callback) {
    axios({
      method: method,
      url: url,
      mode: "cors",
      credentials: "origin",
      crossOrigin: true,
      data: querystring.stringify(options)
    })
      .then(response => {
        //return Promise.resolve(callback(response));
        callback(response);
      })
      .catch(error => {
        //console.log(error);
        //return Promise.resolve(true);
      });

    // let body = querystring.stringify(options);
    // if (xhr) {
    //     xhr.open('POST', url, true);
    //     //xhr.setRequestHeader('X-PINGOTHER', 'pingpong');
    //     xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    //     xhr.setRequestHeader('page-encoding', 'UTF-8');
    //     xhr.onreadystatechange = () => {
    //         if (this.readyState == 4 && this.status == 200){
    //             xhr.getResponseHeader('Content-Type', 'application/json; charset=UTF-8');
    //
    //         }
    //     };
    //     xhr.send(body);
    // }
  },

  sendServer3(url, options, method, callback) {
    axios({
      method: method,
      url: url,
      mode: "cors",
      credentials: "origin",
      crossOrigin: true,
      data: querystring.stringify(options)
    })
      .then(response => {
        callback(response);
      })
      .catch(error => {
        let modalOptions = {
          title: "문자발송",
          html: "문자가 발송되었습니다.",
          showCancelButton: false,
          confirmButtonClass: "md-button md-info",
          cancelButtonClass: "md-button md-default",
          confirmButtonText: "확인",
          buttonsStyling: false
        };
        Swal.fire(modalOptions);
      });
  },

  // added by psk 20200828
  sendServerMixData(url, options, method, callback) {
    let modalOptions = {
      type: "warning",
      showCancelButton: false,
      confirmButtonClass: "md-button md-info",
      cancelButtonClass: "md-button md-default",
      confirmButtonText: "확인",
      buttonsStyling: false
    };
    modalOptions.showConfirmButton = false;
    modalOptions.html = "통신 중 입니다.";
    Swal.fire(modalOptions);
    axios({
      method: method,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Auth-Token": session.get("token")
      },
      url: url,
      data: options
    })
      .then(response => {
        Swal.close();
        //        console.log("kuaaApi.sendServerMixData() success: ", response);
        callback(response);
      })
      .catch(error => {
        Swal.close();
        //       console.log("kuaaApi.sendServerMixData() failed", error);
        modalOptions.html = `서버 통신 과정에서 오류가 발생했습니다.`;
        Swal.fire(modalOptions);
      });
  },

  requestFileDownload(url, options, fileName, callback) {
    let modalOptions = {
      type: "warning",
      showCancelButton: false,
      confirmButtonClass: "md-button md-info",
      cancelButtonClass: "md-button md-default",
      confirmButtonText: "확인",
      buttonsStyling: false
    };

    axios({
      method: "POST",
      url: url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      },
      data: options
    })
      .then(response => {
        //console.log(response, typeof response);
        //console.log(response.headers['fileName']);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(
          new Blob([response.data], { type: response.headers["content-type"] })
        );
        link.download = fileName;
        link.click();
        callback(response);
      })
      .catch(error => {
        //       console.log("kuaaApi.sendServerMixData() failed", error);
        /*                modalOptions.html = `서버 통신 과정에서 오류가 발생했습니다.`;
                Swal.fire(modalOptions);*/
      });
  }
};
export default kuaaApi;
